import React from "react";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";
import { Add, Edit } from "@mui/icons-material";
import { Typography, Grid, Button } from "@mui/material";

export default function PageHeader({
  title = "",
  pageName,
  pageHeader = "",
  icons = [],
  breadcrumbs = [],
  addIcon = [],
  editIcon = [],
  buttons = [],
}) {
  const [buttonTitle, URL, createPermission] = addIcon;
  const [editState, setEditState, updatePermission] = editIcon;

  const navigate = useNavigate();

  return (
    <React.Fragment>
      <Helmet title={title || pageName} />

      <Grid container alignItems="center">
        <Grid size="auto">
          <Typography variant="h4">{pageName}</Typography>

          {pageHeader && (
            <Typography
              variant="h6"
              style={{ opacity: "0.7", marginTop: "4px" }}
            >
              {pageHeader}
            </Typography>
          )}
        </Grid>

        <Grid size="auto" offset={{ sm: "auto" }} />

        <Grid
          size="auto"
          container
          justifyContent="flex-end"
          style={{ gap: "5px" }}
        >
          {icons.length > 0 &&
            icons.map((icon, index) => (
              <Grid alignSelf={"center"} item key={index}>
                {icon}
              </Grid>
            ))}

          {buttons.length > 0 &&
            buttons.map((icon, index) => (
              <Grid alignSelf={"center"} item key={index}>
                {icon}
              </Grid>
            ))}

          {createPermission && (
            <Grid size>
              <Button
                variant="contained"
                color="primary"
                startIcon={<Add />}
                onClick={() => navigate(URL)}
              >
                {buttonTitle}
              </Button>
            </Grid>
          )}

          {!editState && updatePermission && (
            <Grid size>
              <Button
                variant="contained"
                color="primary"
                startIcon={<Edit />}
                onClick={() => setEditState((prevValue) => !prevValue)}
              >
                Edit
              </Button>
            </Grid>
          )}
        </Grid>

        <Grid size={12} style={{ marginBlock: "14px" }}></Grid>
      </Grid>
    </React.Fragment>
  );
}
